export default function InputError({error}: {error?: string}) {
	if (error === undefined) return null;

	return <span className='text-red-400 text-[14px]'>{error}</span>;
}
